import { z } from "zod";

export const ApiKeySchema = z.object({
  id: z.string(),
  key: z.string(),
  createdAt: z.string(),
  lastUsed: z.string().nullable(),
  userId: z.string(),
  name: z.string().optional(),
  workspaceId: z.string().nullable().optional(),
});

export type ApiKey = z.infer<typeof ApiKeySchema>;
